import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { ArrowRight, Menu, X } from "lucide-react";

export default function PublicNav() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: "/features", label: "Features" },
    { to: "/pricing", label: "Pricing" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="px-6 py-4 relative" style={{ borderBottom: "1px solid #e2e8f0" }}>
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <Logo size="small" />

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm font-medium transition-colors"
              style={{ color: isActive(link.to) ? "#6366f1" : "#64748b" }}
              onMouseEnter={(e) => (e.target.style.color = "#6366f1")}
              onMouseLeave={(e) => (e.target.style.color = isActive(link.to) ? "#6366f1" : "#64748b")}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white transition-all hover:scale-105"
            style={{ background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)" }}
          >
            Get Started
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 rounded-lg transition-colors"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{ color: "#64748b" }}
        >
          {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div
          className="md:hidden absolute top-full left-0 right-0 z-50 px-6 py-4 animate-fade-in"
          style={{
            background: "#ffffff",
            borderBottom: "1px solid #e2e8f0",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div className="flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setIsMenuOpen(false)}
                className="px-4 py-3 rounded-lg text-sm font-medium transition-colors"
                style={{
                  color: isActive(link.to) ? "#6366f1" : "#1e293b",
                  background: isActive(link.to) ? "rgba(99, 102, 241, 0.1)" : "transparent",
                }}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-sm font-medium text-white mt-2"
              style={{ background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)" }}
            >
              Get Started
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
